import $ from "jquery";

/**
 * initializes the Click events for the sitemap
 *
 */
export function initSitemap() {
  const $sitemap = $("div#sitemap");
  const $sitemapOpener = $("a[href^='#sitemap']");
  const $sitemapCloser = $("a.closeButton");

  $sitemapOpener.on("click", () => {
    $sitemap.show(1000);
    let headerHeight = $("header").height();
    let offset = $sitemap.offset().top - headerHeight;
    $("html, body").animate({
      scrollTop: offset
    }, 1000);
  });

  $sitemapCloser.on("click", (ev) => {
    ev.preventDefault();

    $sitemap.hide(1000);
  });
}
